import { router } from "@inertiajs/react";
import { Table } from "@mantine/core";
import { StatusIndicator } from "../../../components/indicator/StatusIndicator";
import { UserView } from "../../../components/user/UserView";
import { getFullName } from "../../../helpers/stringHelper";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Coach } from "../../../models/coach";
import { coaches_path } from "../../../routes";

type CoachViewProps = {
  coach: Coach;
};

export default function CoachView({ coach }: CoachViewProps) {
  const { pathWithYearContext } = useYearContext();

  const onBack = () => router.get(pathWithYearContext(coaches_path));
  return (
    <ContentShell title={`Coach ${getFullName(coach)}`} titleIcon={<StatusIndicator active={coach.user.active} />} onBack={onBack}>
      <Table variant="vertical" layout="fixed" withTableBorder>
        <Table.Tbody>
          <UserView<Coach> userType={coach} />
        </Table.Tbody>
      </Table>
    </ContentShell>
  );
}
